import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import useOnClickOutside from '../../../hooks/useOnClickOutside';
import SwitchBig from '../../../components/SwitchBig';
import {
  selectSecondaryFilter,
  updateSecondaryFilter,
} from '../secondaryFilterSlice';
import { t } from '../../../utilities/translator';
import { scrollToResults } from '../../../utilities/helpers';
import { pushEvent } from '../../../utilities/analytics';
import {
  LUGGAGE_FILTER_UPDATE_EVENT,
  SEC_FILTER_OPEN,
} from '../../../constants/analyticEvents';
// import { clearSelectedHotel } from '../../search/searchSlice';
import { filterClearClick, filterSaveClick, setLastChangedFilter } from '../../../appSlice';
import { clearPrefetchDeals } from '../../dealsList/prefetchDealsSlice';
import { updateSecondaryFilterModal } from '../secondaryFilterModalsSlice';

export default function BaggageRate({ setIsOpen, side }) {
  const { data } = useSelector(selectSecondaryFilter);
  const dealsCount = useSelector(state => state.dealsList.dealsList).length;
  const { mainFilter, secondaryFilter } = useSelector(state => state.modals)
  const { luggage: isOpen, luggageTouched, ...otherFilters } = { ...mainFilter, ...secondaryFilter };
  const { luggage } = data;
  const name = t('secondaryFilter.luggage');

  const ref = useRef();
  const initializeRef = useRef(false);
  const dispatch = useDispatch();
  const [localLuggageState, setLocalLuggageState] = useState(luggage);

  useOnClickOutside(ref, () => isOpen && luggageTouched && setIsOpen(false));

  useEffect(() => {
    if (!isOpen) return

    if (dealsCount > 0) {
      initializeRef.current = true;
    }

    if (Object.values(otherFilters).some(Boolean) && initializeRef.current) {
      openFilter(false);
    }
  }, [isOpen, otherFilters, dealsCount]);

  useEffect(() => {
    if (luggage?.filter((bag) => bag.active)?.length !== localLuggageState?.filter((bag) => bag.active)?.length) {
      setLocalLuggageState(luggage);
    }
  }, [luggage]);

  const onClearClick = (event) => {
    setIsOpen(false);
    dispatch(filterClearClick());
    const newLocalLuggageState = localLuggageState.map((item) => ({ ...item, active: false }));
    dispatch(
      updateSecondaryFilter({ updatedValue: newLocalLuggageState, filter: 'luggage' })
    );
    dispatch(updateSecondaryFilterModal({ luggageTouched: true }));
    setLocalLuggageState(newLocalLuggageState);
    event.stopPropagation();
    scrollToResults();
    pushEvent(LUGGAGE_FILTER_UPDATE_EVENT, { luggage: newLocalLuggageState, type: 'clear' });
  };

  const openFilter = () => {
    if (!isOpen) {
      pushEvent(SEC_FILTER_OPEN, { filterName: 'luggage' });
    }
    setIsOpen(!isOpen);
    dispatch(updateSecondaryFilterModal({ luggageTouched: true }));

    /* if (!localStorage.getItem('luggageFilterInteracted')) {
      localStorage.setItem('luggageFilterInteracted', true);
    } */
  };

  const closeFilter = () => {
    setIsOpen(false);
    dispatch(updateSecondaryFilterModal({ luggageTouched: true }));
    /* if (!localStorage.getItem('luggageFilterInteracted')) {
      localStorage.setItem('luggageFilterInteracted', true);
    } */
  };

  const changeBaggage = (bagType) => {
    console.log("Change baggage:", bagType, localLuggageState);
    const newLocalLuggageState = localLuggageState.map((item) =>
      item.value === bagType ? { ...item, active: !item.active } : item
    );
    dispatch(filterSaveClick());
    dispatch(clearPrefetchDeals());
    dispatch(
      updateSecondaryFilter({ updatedValue: newLocalLuggageState, filter: 'luggage' })
    );
    dispatch(setLastChangedFilter('secondaryFilter'));
    setLocalLuggageState(newLocalLuggageState);
    dispatch(updateSecondaryFilterModal({ luggageTouched: true }));
    // dispatch(clearSelectedHotel()); // don't reset 'search by hotel name' on flight filters
    setTimeout(() => setIsOpen(false), 600);
    pushEvent(LUGGAGE_FILTER_UPDATE_EVENT, { luggage: newLocalLuggageState, type: 'save', bagType });
  };

  const isActiveFilter = localLuggageState.some(bag => bag.active);

  let activeName = '';
  if (isActiveFilter) {
    activeName = localLuggageState.filter(bag => bag.active).map(bag2 => bag2.label).join(', ');
  }

  return (
    <div className={classNames("filter-item filter-item-v2 filter-item-baggage", { 'fibag-not-touched': !luggageTouched })} ref={ref}>
      <p
        className={`filter-item__name ${
          isOpen ? 'filter-item__name-open' : ''
        } ${isActiveFilter ? 'filter-item__name-active' : ''}`}
        onClick={openFilter}
        role="menuitem"
        ref={ref}
        tabIndex="0"
      >
        <span>{isActiveFilter ? activeName : name}</span>
        {isActiveFilter ? (
          <i onClick={onClearClick} className="ri-close-line close" />
        ) : (
          <i className="ri-arrow-down-s-line chevron" />
        )}
      </p>
      {isOpen && (
        <div className={classNames(`filter-body filter-body-baggage ${side}`, { 'fbbag-not-touched': !luggageTouched })} style={{ minWidth: '360px' }}>
          <div className="fbbag-wrap flex flex-col gap-5">
            <div className="fbbag-title flex items-center justify-between gap-1">
              <div
                className="fbbag-label text-start"
                dangerouslySetInnerHTML={{
                  __html: t('secondaryFilter.luggageSubTitle'),
                }}
              />
              <span className="fbbag-close" onClick={closeFilter}><i className="ri-close-line" /></span>
            </div>
            {
              luggage.map((bag, i) => (
                <SwitchBig
                  key={i}
                  className="label-medium move-switch flex justify-between"
                  value={bag.active}
                  label={bag.label}
                  onChange={() => changeBaggage(bag.value)}
                />
              ))
            }
          </div>
        </div>
      )}
    </div>
  );
}
